import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { WebhookEndpointList } from '@/components/webhooks/WebhookEndpointList'
import { WebhookDeliveryTable } from '@/components/webhooks/WebhookDeliveryTable'

export function OutboundWebhooks() {
  return (
    <Tabs defaultValue="endpoints" className="w-full">
      <TabsList>
        <TabsTrigger value="endpoints">Endpoints</TabsTrigger>
        <TabsTrigger value="deliveries">Delivery Logs</TabsTrigger>
      </TabsList>
      <TabsContent value="endpoints" className="mt-4">
        <WebhookEndpointList />
      </TabsContent>
      <TabsContent value="deliveries" className="mt-4">
        <WebhookDeliveryTable />
      </TabsContent>
    </Tabs>
  )
}
